type SymbolCardProps = {
  name: string;
  meaning: string;
};

export function SymbolCard({ name, meaning }: SymbolCardProps) {
  return (
    <article className="symbol-card">
      <span aria-hidden="true" />
      <h3>{name}</h3>
      <p>{meaning}</p>
    </article>
  );
}
